export default {
  en: {
    card: [
      {
        title: 'Digital Database',
        description: 'Save your pet\'s information in our secure database. Information at tip of your fingers, whenever you need it.',
        icon: require('ui/staticSiteData/descriptionForPetOwnersData/images/image1.svg'),
      },
      {
        title: 'Instructions and Reminders',
        description: 'Set alarms to renew registration or give medication — and create easy-to-follow dosage instructions.',
        icon: require('ui/staticSiteData/descriptionForPetOwnersData/images/image2.svg'),
      },
      {
        title: 'Access Reviews',
        description: 'Browse over hundreds of local service providers, sorted by rating.',
        icon: require('ui/staticSiteData/descriptionForPetOwnersData/images/image3.svg'),
      },
      {
        title: 'Online Scheduling',
        description: 'Set appointments directly through our app or online portal.',
        icon: require('ui/staticSiteData/descriptionForPetOwnersData/images/image4.svg'),
      },
    ],
    button: {
      text: 'Create a profile',
      link: '#',
    }
  }
};
